module.exports = __webpack_public_path__ + "media/images/flags/sc-6767d221d68684de8312dfde8c83fd38.svg";